const ShipmentActionEnum = {
  ACCEPT: 'accept',
  REJECT: 'reject',
  THROW_ABSENCE: 'absence'
}
  export default ShipmentActionEnum